import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { drag } from 'd3-drag';
import { select } from 'd3-selection';
import { IPointerViewModel } from '../../../models/interfaces';

@Component({
    selector: '[trace-pointer]',
    templateUrl: './pointer.component.html',
    styleUrls: ['./pointer.component.css'],
    standalone: true,
})
export class PointerComponent implements OnInit {
    // events

    @Output()
    intersectionChange = new EventEmitter<{ x: number; y: number }>();

    // data members

    @Input()
    pointer!: IPointerViewModel;

    // constructor

    constructor(private elementRef: ElementRef) {}

    // public functions

    ngOnInit() {
        let onDrag = drag()
            .on('start', (event) => {
                event.sourceEvent.stopPropagation();

                this.pointer.selected = true;
                const intersection = this.pointer.intersection.getIntersection(event.x);

                this.pointer.textX = event.x + 10;
                this.pointer.tooltipOpacity = 1;
                this.pointer.tooltip = '(x: ' + intersection.x.toFixed(3) + ', y: ' + intersection.y.toFixed(3) + ')';
            })
            .on('drag', (event) => {
                if (!this.pointer.selected) return;

                this.pointer.positionX = event.x;
                this.intersectionChange.emit(this.pointer.currentIntersection);
            })
            .on('end', () => {
                this.pointer.selected = false;
                this.pointer.tooltipOpacity = 0;
            });

        select(this.elementRef.nativeElement).call(onDrag);
    }
}
